import { useState, useEffect, useCallback } from 'react';
import { getModulesWithLiveStatus } from './getModuleSchedule';

/**
 * Custom hook to automatically update live session status
 * @param {string} studentUid - Student's UID
 * @param {number} refreshInterval - Refresh interval in milliseconds (default: 60000 = 1 minute)
 * @returns {Object} { moduleSchedules, refreshSchedules, isLoading }
 */
export const useLiveSessionUpdater = (studentUid, refreshInterval = 60000) => {
    const [moduleSchedules, setModuleSchedules] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const refreshSchedules = useCallback(async () => {
        if (!studentUid) return;
        
        try {
            const schedules = await getModulesWithLiveStatus(studentUid);
            setModuleSchedules(schedules);
        } catch (error) {
            console.error('Error refreshing module schedules:', error);
        } finally {
            setIsLoading(false);
        }
    }, [studentUid]);

    // Initial load
    useEffect(() => {
        refreshSchedules();
    }, [refreshSchedules]);

    // Auto-refresh interval
    useEffect(() => {
        if (!studentUid) return;

        const interval = setInterval(() => {
            refreshSchedules();
        }, refreshInterval);

        return () => clearInterval(interval);
    }, [studentUid, refreshInterval, refreshSchedules]);

    return {
        moduleSchedules,
        refreshSchedules,
        isLoading
    };
};